import { AppState } from '@fullstory/redux/types';
import { NAME } from './constants';
import { annotationsAdapter } from './adapters';
import { partial } from 'lodash';

/** Returns the root annotations state. */
const getAnnotationsState = (state: AppState) => state[NAME];

// ---------- Access Selectors ----------

/** Returns the annotations access (permissions) state. */
export const getAnnotationsAccess = (state: AppState) => getAnnotationsState(state).access;

// ---------- Annotations Selectors & Factories ----------

/** Returns the annotations entity adapter state. */
const getAnnotationsAdapterState = (state: AppState) => getAnnotationsState(state).annotations;

/** Takes an ID and returns a selector to return that annotation. */
export const makeGetAnnotationsById = partial(
  annotationsAdapter.createSelectById,
  getAnnotationsAdapterState,
);

/** Takes an attributes object and returns a selector that finds matching annotations */
export const makeGetAnnotationsByAttributes = partial(
  annotationsAdapter.createSelectByAttributes,
  getAnnotationsAdapterState,
);

/** Takes a dxObjectId and returns a selector that finds annotations associated with it */
export const makeGetAnnotationsByDxObjectId = (dxObjectId: string) => {
  const attributes = {
    association: { dxObjectId },
  };

  return makeGetAnnotationsByAttributes(attributes);
};

/** Takes a dxObjectId and returns a selector that finds annotations associated with it */
export const makeGetGlobalAnnotations = () => {
  const attributes = {
    global: true,
  };

  return makeGetAnnotationsByAttributes(attributes);
};
